/**
 * @title zoom-viewer.js: Sub-module of Browse feature
 * @description This module encapsulates all of the
 * functionality related to the zoom viewer component of quickview display.
 * @dependency 
 */
define([], function() {
  var ZoomViewer = {
    getViewerSize: function() {
      var width = $(window).width();
  	var height = $(window).height();
      if (width > 1000 && height > 870 || width <= 667 && width > 382) return zoomViewer.xl;
      if (width > 764 && height > 650) return zoomViewer.lg;
      return zoomViewer.xs;
    },
    
    richMediaLoaded: function() {
      ZoomViewer.setupViewer();
      ZoomViewer.setupSwatches();
      ZoomViewer.constants.$initialImage.hide(); //hide the overlayed image after zoom viewer finishes loading
      ZoomViewer.constants.$viewerDiv.css('visibility', 'visible');
      ZoomViewer.constants.$viewerDiv.find('#productImageContainer').focus();
      ZoomViewer.constants.$prevArrow.addClass('slick-prev').css('visibility', 'visible');
      ZoomViewer.constants.$nextArrow.addClass('slick-next').css('visibility', 'visible');
      let $externalVideo = ZoomViewer.constants.$theViews.find('img[id*=External]');
      if ($externalVideo.length > 0) { //only load liveclicker files once
        ZoomViewer.loadVideoData();
      }
      
      if (ZoomViewer.constants.imageLightboxV2) {
    	  let slides = ZoomViewer.constants.$theViews.find('a').length;
    	  $('#currentSlide').html((COSTCO.ZoomViewer.constants.currentSlide + 1) +  messages.PDP_REDESIGN_V2_OF + slides);
      }
      
    },
    
    richMediaSwatchChange: function() {
  
      if (ZoomViewer.constants.$theViews.hasClass('slick-initialized')) {
        ZoomViewer.destroyThumbnailCarousel();
        ZoomViewer.constants.currentSlide = 0;
        ZoomViewer.constants.firstActiveSlide = 0;
        ZoomViewer.makeViewerResponsive();
        ZoomViewer.setupThumbnailCarousel();
      }
    },
    
    richMediaViewChange: function() {
    	var $selected = $('.RICHFXColorChangeViewSelected');
	    ZoomViewer.destroyThumbnailCarousel();
	    ZoomViewer.constants.currentSlide = $selected.parent().index();
	    ZoomViewer.makeViewerResponsive();
	    ZoomViewer.setupThumbnailCarousel();
		$('.selectedSlide').first().focus();
	    if (ZoomViewer.constants.imageLightboxV2) {
    		let slides = $('#theViews').find('a').length;
    		$('#viewsPrevArrow').removeClass('hideViewsArrow');
	    	$('#viewsNextArrow').removeClass('hideViewsArrow');	    	
	    	if (ZoomViewer.constants.currentSlide == slides - 1 ) {
				$('#viewsNextArrow').addClass('hideViewsArrow');
			}
			if (ZoomViewer.constants.currentSlide == 0) {
				$('#viewsPrevArrow').addClass('hideViewsArrow');
			}
	    	$('#currentSlide').html((COSTCO.ZoomViewer.constants.currentSlide + 1) +  messages.PDP_REDESIGN_V2_OF + slides);
	    }      
    },
    
    initZoomViewer: function() {
      console.log('Calling InitZoomViewer...');   
	  ZoomViewer.constants = {
        $viewerDiv: $('#zoomViewer'),
        $viewerLib: $('#productImageLibrary'),
        $viewerImg: $('#productImage'),
        $thumbnails: $('#thumbnails'),
        $theViews: $('#theViews'),
        $initialImage: $('#initialProductImage'),
        $prevArrow: $('#viewsPrevArrow'),
        $nextArrow: $('#viewsNextArrow'),
        viewerSize: ZoomViewer.getViewerSize(),
        currentSlide: 0,
        firstActiveSlide: 0,
        imageLightboxV2: false
	  };
      
      ZoomViewer.createViewer(ZoomViewer.constants.viewerSize);
    },
    
    createViewer: function(viewerSize) {
    	//[Vladimir] the following line is from original script, this is now already included in SearchResultsBody page
      //$viewerLib.attr('src', zoomViewer.libraryUrl + viewerSize);
      ZoomViewer.constants.$viewerImg.attr('src', zoomViewer.viewerUrl + viewerSize.substr(2));
    },
    
    //adjusts thumbnail width and position of video overlay images
    adjustThumbnails: function() {
      let thumbWidth = Math.floor(ZoomViewer.constants.$theViews.width() / 6);
      ZoomViewer.constants.$theViews.find('img').css('width', thumbWidth);
      
      let $vidOverlay = $('img[id*=videoOverlay]');
      $vidOverlay.each(function() {
        $(this).parent().css('width', '');
        $(this).parent().css('height', '');
        $(this).css('left', $(this).siblings().position().left);
      });
    },
    
    //adds responsive properties to the zoom viewer
    makeViewerResponsive: function() {
      let $container = $('.RICHFXViewerContainer');
      $container.css('width', '');
      $container.css('height', '');
      $('#zoomViewer').find('img').addClass('img-responsive');
    },
    
    //creates thumbnail carousel
    setupThumbnailCarousel: function() {
      if (ZoomViewer.constants.currentSlide == 'undefined') {
        ZoomViewer.constants.currentSlide = 0;
      }
      if (ZoomViewer.constants.firstActiveSlide == 'undefined') {
        ZoomViewer.constants.firstActiveSlide = 0;
      }
      let slides = ZoomViewer.constants.$theViews.find('a').length;
      
      let responsiveBreakpoints = [];
      
      let slickSettings = {
        dots: false,
        arrows: true,
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 5,
        autoplay: false,
        draggable: true,
        accessibility: true,
        prevArrow: $('#viewsPrevArrow'),
        nextArrow: $('#viewsNextArrow')
      }
      
      if (ZoomViewer.constants.imageLightboxV2) {
    	  
    	  let breakPointMobile = {
			breakpoint: 320,
			settings: {
				slidesToShow: 5
			}
    	  };
    	  
    	  responsiveBreakpoints.push(breakPointMobile);
    	  
    	  let breakPoint = {
			breakpoint: 768,
			settings: {
				slidesToShow: 7
			}
    	  };
    	  
    	  responsiveBreakpoints.push(breakPoint);
    	  
    	  slickSettings['responsive'] = responsiveBreakpoints;
    	  slickSettings['slidesToScroll'] = 1;
    	  slickSettings['mobileFirst'] = true;
    	  
    	  let productImageWidth = $('#productImageContainer').find('img:visible').width();
          ZoomViewer.constants.$thumbnails.width(productImageWidth);
      } 
      
      COSTCO.util.carousel(ZoomViewer.constants.$theViews, slickSettings);
      ZoomViewer.constants.$theViews.find('a').on('keyup', function(e) {
        //If user use keyboard enter key to select image simulate the click
        if (e.which == 13) {
          $(this).find('img').click();
          //Move the focus to the selected slide, need to do this as the click simulation reset the focus
          $('.selectedSlide').first().focus();
        }
      });
      ZoomViewer.constants.$theViews.slick('slickGoTo', 5 * (Math.ceil(ZoomViewer.constants.firstActiveSlide / 5)), true); //go to the set of 5 slides that were active
      ZoomViewer.constants.$theViews.find('.selectedSlide').removeClass('selectedSlide');
      ZoomViewer.constants.$theViews.find('.slick-slide:nth-child(' + (ZoomViewer.constants.currentSlide + 1) + ')').addClass('selectedSlide');
      ZoomViewer.adjustThumbnails();
      //if there are more than 5 slides, show the arrows to scroll through thumbs
      if (slides > 5) {
        ZoomViewer.constants.$prevArrow.addClass('slick-prev').css('visibility', 'visible');
        ZoomViewer.constants.$nextArrow.addClass('slick-next').css('visibility', 'visible');
      } else {
        ZoomViewer.constants.$prevArrow.hide();
        ZoomViewer.constants.$nextArrow.hide();
      }
      ZoomViewer.constants.$theViews.unbind('afterChange').on('afterChange', function() {
        ZoomViewer.constants.firstActiveSlide = ZoomViewer.constants.$theViews.find('.slick-active').first().attr('data-slick-index');
      });
    },
    
    //destroys thumbnail carousel
    destroyThumbnailCarousel: function() {
      ZoomViewer.constants.$theViews.slick('destroy');
      ZoomViewer.constants.$theViews.find('a[tabindex]').remove();
      ZoomViewer.constants.$prevArrow.css('visibility', 'hidden');
      ZoomViewer.constants.$nextArrow.css('visibility', 'hidden');
    },
    
    //uses liveclicker's scripts to setup videos
    loadVideoData: function() {
      COSTCO.Global.logger('External Video Detected. Loading Liveclicker.');
      $('#liveClickerCss').attr('href', zoomViewer.videoCssUrl);
      $.cachedScript(zoomViewer.videoJqueryUrl).done(function() {
        $.cachedScript(zoomViewer.videoJsUrl);
      });
      document.addEventListener('RichMedia.ExternalVideo.Show', COSTCO.ZoomViewer.hideZoomInstruction);
      document.addEventListener('RichMedia.ExternalVideo.Hide', COSTCO.ZoomViewer.showZoomInstruction);
    },
    
    hideZoomInstruction: function() {
      $('#zoomInstruction').addClass('hidden-preserve-height');
    },

    showZoomInstruction: function() {
      $('#zoomInstruction').removeClass('hidden-preserve-height');
    },
    
    //selects the first available swatch color from our side so
    //that the customer will not see a color that's unavailable.
    selectInitialSwatch: function() {
      let swatch;
      try {
    	swatch = $('.swatchDropdown').find('option[data-swatch]:not([disabled])').first().data('swatch');
        //trigger a select of the first swatch color from the color select dropdown
        COSTCO.CMath.triggerSwatchDropDownSelection(swatch);
      } catch(err) {
        console.error(err);
      }
      $('#theSwatches').find('img[alt="'+swatch+'"]').first().click();
    },
    
    //out of stock items do not reflect properly in the swatch tiles from rich media
    //so we have to sync their tiles with our product options.
    syncSwatchTiles: function(swatchMode) {
    	var colorsInStock = $.map($('[data-swatch]', '.swatchDropdown'), function(option) { 
			if($(option).attr("disabled") != "disabled"){
	    		return $(option).data('swatch').trim().toLowerCase(); 
	    	}
		});
		var colorsOutStock = $.map($('[data-swatch]', '.swatchDropdown'), function(option) { 
			if($(option).attr("disabled") == "disabled"){
	    		return $(option).data('swatch').trim().toLowerCase(); 
	    	}
		});
		var colorsNames = $.map($('[data-swatch]', '.swatchDropdown'), function(option) { 
			if($(option).text().includes(messages.BACKORDER_TEXT)) {
				var sliceStr = ' - '+ messages.BACKORDER_TEXT;
				return $(option).text().slice(0, $(option).text().indexOf(sliceStr))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
			} else if($(option).text().includes(messages.OUT_OF_STOCK_TEXT)) {
				var sliceStr = ' - '+ messages.OUT_OF_STOCK_TEXT;
				return $(option).text().slice(0, $(option).text().indexOf(sliceStr))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
			} else if($(option).text().includes(' -')) {
				return $(option).text().slice(0, $(option).text().indexOf(' -'))+ " -"+$(option).data('swatch').trim().toLowerCase()+"-";
			} else {
				return $(option).text() + " -"+$(option).data('swatch').trim().toLowerCase()+"-";
			}	
		});
      
      $('img', '#theSwatches').each(function() {
        var itemDescriptionArray = $(this).siblings('span.RICHFXColorChangeSwatchName')[0].innerHTML.split(" ");
        if (itemDescriptionArray.length == 2) {
          var color = itemDescriptionArray[1].toLowerCase();
          var colorNameTitle = $.map(colorsNames, function (value){
				if(value.includes(' -'+color)){
					return value.slice(0, value.indexOf(' -'+color+'-')); 
				}
          });
          if (colorsInStock.indexOf(color) < 0 && colorsOutStock.indexOf(color) < 0) {
			$(this).parent().remove();
          } else if(colorsInStock.indexOf(color) < 0 ) {
			$(this).parent().addClass('disabledSwatch');
			if(color == 'white'){
				$(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-grey.png" class="disableOverlaySwatch" />');
			}else {
				$(this).parent().append('<img src="/wcsstore/RWDStaticAssets/fonts/fallback-icons/icons/swatch-disabled-white.png" class="disableOverlaySwatch" />');
			}
			$(this).parent().get(0).setAttribute("tabindex", "-1");
			$(this).parent().wrap('<span class="swatch-help" data-placement="bottom" data-trigger="focus hover" data-toggle="popover" data-html="true" data-content="'+colorNameTitle + ' ' + messages.OUT_OF_STOCK_TOOLTIP + '" />');
			$(this).parent().prepend('<span class="offscreen">' +colorNameTitle + ' '+ messages.OUT_OF_STOCK_TOOLTIP +'</span>');
          }else {
			$(this).parent().get(0).setAttribute("data-sort", colorsInStock.indexOf(color));
			
			$(this).parent().get(0).setAttribute("data-content", colorNameTitle);
			$(this).parent().get(0).setAttribute("data-placement", "bottom");
			$(this).parent().get(0).setAttribute("data-trigger", "focus hover");
			$(this).parent().get(0).setAttribute("data-toggle", "popover");
			$(this).parent().get(0).setAttribute("data-html", "true");
			$(this).parent().get(0).classList.add("swatch-help");
			$(this).parent().get(0).setAttribute("onkeydown", "COSTCO.CMath.runRMAActiveColor(event, '" + color + "')");
          }
        }
      });
      
      var sortedSwatches = $('#theSwatches').children().sort(function(a,b){
        return a.getAttribute('data-sort') - b.getAttribute('data-sort');
      });
      
      $('#theSwatches').empty();
      $('#theSwatches').append(sortedSwatches);
      if (swatchMode == 2) {
        $('#theSwatches').removeClass('hide');
      }
      
    },
    
    //sets up swatches based on swatchMode
    //swatchMode = 1 is the regular dropdown
    //swatchMode = 2 is RichFx's swatch color tiles and we hide our dropdown
    setupSwatches: function() {
      let swatchMode = $('.swatchDropdown').data('swatch-mode');
      
      if (swatchMode == 1 || swatchMode == 2) {
        ZoomViewer.syncSwatchTiles(swatchMode);
        ZoomViewer.selectInitialSwatch();
        
        //fallback to our select if RichFx's swatch tiles didn't load
        if (swatchMode == 2 && $('#theSwatches').children().length == 0) {
          $('.swatchDropdown').removeClass('hide');
        }
        COSTCO.util.swatch_accesible_popover('.swatch-help');
      } else {
			$('#product-body-item-number').removeClass('hide');
			$('#product-body-model-number').removeClass('hide');
      }
    },
    
    //setus up the viewer to have responsive properties and
    //shows thumbnails if they are available
    setupViewer: function() {
      ZoomViewer.makeViewerResponsive();
      if (ZoomViewer.constants.$theViews.find('img').length > 0) {
        ZoomViewer.constants.$thumbnails.show();
        ZoomViewer.setupThumbnailCarousel();
      }
    },
    
    cleanupEvents: function() {
      document.removeEventListener('richmedia.state.loaded', COSTCO.ZoomViewer.richMediaLoaded);
      document.removeEventListener('richmedia.swatch.changed', COSTCO.ZoomViewer.richMediaSwatchChange);
      document.removeEventListener('richmedia.view.changed', COSTCO.ZoomViewer.richMediaViewChange);
      document.removeEventListener('RichMedia.ExternalVideo.Show', COSTCO.ZoomViewer.hideZoomInstruction);
      document.removeEventListener('RichMedia.ExternalVideo.Hide', COSTCO.ZoomViewer.showZoomInstruction);
      jQuery(document).unbind();
    },
    
    /**
     * Resets Liveclicker video player.
     */
    resetLiveclicker: function() {
      if (typeof liveclicker != 'undefined') {
        liveclicker = {
          lcCheckReadyObject: function() {},
        }
      }
    },
    /**
     * This event-bound function "locks" window position, since the external Liveclicker library has several
     * window.scrollTo() executions that cause the background to scroll down after each click on a video.
     */ 
    lockWindowScrolling: function(event) {
		if (typeof event.data.position != 'undefined') {
		  $(window).scrollTop(event.data.position);
		}
    },
	/**
	 * Liveclicker library may break, leaving the thumbnails un-reloaded.
	 * Until this is fixed on the Liveclicker side, use this error event listener function.
	 */ 
    reloadThumbnailsOnScriptError: function(event) {
		if (event.originalEvent.message == 'Script error.') {
		  try {
		    console.error('A script error occurred. Reloading thumbnails.');
		    ZoomViewer.richMediaViewChange();
		  } catch (err) {
		    console.error('An error occurred while trying to reload thumbnails.');
		  }
		}
    }
    
  }
  
  if (typeof window.COSTCO == 'undefined') {
    window.COSTCO = new Object();
  }
  
  window.COSTCO.ZoomViewer = ZoomViewer;
  
  return ZoomViewer;
});



// WEBPACK FOOTER //
// ./js/browse/zoom-viewer.js